
  var rt = require("@stylable/runtime/cjs/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "DropdownLayout3674592898",
      {"classes":{"root":"DropdownLayout3674592898__root","contentContainer":"DropdownLayout3674592898__contentContainer","options":"DropdownLayout3674592898__options","option":"DropdownLayout3674592898__option","selectableOption":"DropdownLayout3674592898__selectableOption","arrow":"DropdownLayout3674592898__arrow","loader":"DropdownLayout3674592898__loader","linkItem":"DropdownLayout3674592898__linkItem"},"vars":{},"stVars":{"option_height":"36px","big_option_height":"47px","top-arrow-size":"8px","arrowUpShadow":"3px 3px 8px rgba(0, 0, 0, .1)","arrowDownShadow":"-3px -3px 8px rgba(0, 0, 0, .1)"},"keyframes":{}},
      "",
      -1,
      module.id
  );
  